module.exports = __webpack_public_path__ + "static/img/hr121.e924e8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/hr121.jpg
// module id = VwGW
// module chunks = 0